import React from 'react';
import PropTypes from 'prop-types';
import { LoadingCard, ScoreCard } from '../../../components/cards';
import SectionHeading from '../../../components/text/SectionHeading';
import { MatchFormatTypes } from '../../../utils/postScoreConstants';
import { EventTypes } from '../../../utils/clubs';

const RecentResults = ({ recentResults, auth, history }) => {
    return (
        <>
            {recentResults ? (
                <>
                    {auth.user.claimedPlayer && (
                        <>
                            <div className="row">
                                <div className="col-12">
                                    <SectionHeading title={'Recent results'} className={'mb16'} data-testid="dashboard.recent-results.section-heading" />
                                    {recentResults?.length > 3 && (
                                        <div
                                            className={`clickable link`}
                                            onClick={() => {
                                                history.push({
                                                    pathname: `/profiles/${auth.user.claimedPlayer.playerId}`,
                                                    state: {
                                                        openResultsTab: true,
                                                    },
                                                });
                                            }}
                                            data-testid="dashboard.recent-results.view-all-btn"
                                        >
                                            View All
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                {recentResults.map((recentResult, i) => {
                                    if (i < 3) {
                                        const isLeaguesMatch = recentResult.resultType === EventTypes.LEAGUES;
                                        return (
                                            <div className={`col-12 col-md-4 col-xl-4`} key={`recentResult-${recentResult.id}`}>
                                                <ScoreCard
                                                    key={`match-item-${recentResult.id}`}
                                                    {...recentResult}
                                                    gameType={recentResult?.players?.winner2 || recentResult?.players?.loser2 ? MatchFormatTypes.DOUBLES : MatchFormatTypes.SINGLES}
                                                    playerId={auth.user.claimedPlayer.playerId}
                                                    timeZoneValue={'UTC'}
                                                    isLeaguesMatch={isLeaguesMatch}
                                                    showVerified={false}
                                                    forceCardView={true}
                                                    data-testid={`dashboard.recent-results.item-${recentResult.id}`}
                                                />
                                            </div>
                                        );
                                    }
                                    return <div />;
                                })}
                                {recentResults?.length === 0 && <p style={{ marginLeft: 10 }} data-testid="dashboard.recent-results.empty-message">There are no recent results for the selected sport type</p>}
                            </div>
                        </>
                    )}
                </>
            ) : (
                <>
                    <div className={`hp-title`} data-testid="dashboard.recent-results.loading-title">
                        Recent results
                    </div>
                    <div className="row">
                        <div className={`col-12`}>
                            <LoadingCard data-testid="dashboard.recent-results.loading-card" />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

RecentResults.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    recentResults: PropTypes.instanceOf(Array),
};

RecentResults.defaultProps = {
    recentResults: [],
};

export default RecentResults;
